import { makeVar } from '@apollo/client'
import { TSCookies } from './cookie.types'

type CookieVars = {
  openCookieDialog: boolean,
  cookieSettings: { [key in TSCookies]?: boolean }
}

export const cookieVars = makeVar<CookieVars>({ openCookieDialog: false, cookieSettings: {} })
